import { render, staticRenderFns } from "./SelectDuration.vue?vue&type=template&id=63569399&"
import script from "./SelectDuration.vue?vue&type=script&lang=js&"
export * from "./SelectDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports